export const MODULE_META = {
  asm: {
    label: "Attack Surface Intelligence",
    to: "/asm",
    accentText: "text-primary",
    accentGradient: "from-primary-container to-transparent",
    badgeBg: "bg-primary-container/10 border-primary-container/20",
  },
  dri: {
    label: "Digital Risk Intelligence",
    to: "/dri",
    accentText: "text-secondary",
    accentGradient: "from-secondary-container to-transparent",
    badgeBg: "bg-secondary-container/10 border-secondary-container/20",
  },
  compliance: {
    label: "Compliance & Cloud Security",
    to: "/compliance",
    accentText: "text-on-surface dark:text-surface-bright",
    accentGradient: "from-primary-container via-surface-variant to-secondary-container",
    badgeBg: "bg-surface-variant/40 border-glass",
  },
  platform: {
    label: "The CyberMon Platform",
    to: "/",
    accentText: "text-on-surface dark:text-surface-bright",
    accentGradient: "from-primary-container via-surface-variant to-secondary-container",
    badgeBg: "bg-surface-variant/40 border-glass",
  },
};

// Sourced from the redesigned collateral set (updated/01-Ready-to-send, 13 Sep 2026 —
// see that folder's CHANGELOG.md). Descriptions reflect each document's own content;
// nothing here asserts a claim beyond what that specific PDF states.
export const RESOURCES = [
  {
    id: "asm-flyer",
    module: "asm",
    type: "flyer",
    typeLabel: "1-Page Flyer",
    pages: 1,
    title: "Attack Surface Intelligence Flyer",
    description:
      "The forgotten subdomain, the exposed login page with no MFA, the expiring certificate, the AI endpoint on no register — and how ASI finds them first.",
    useCase: "Cold outreach, event handout, leave-behind",
    file: "/resources/CyberMon_ASI_Flyer.pdf",
  },
  {
    id: "asm-coverage",
    module: "asm",
    type: "coverage",
    typeLabel: "Coverage Document",
    pages: 6,
    title: "Attack Surface Intelligence Coverage Document",
    description:
      "What ASI discovers, what it checks — now including login/MFA exposure — how it differs from annual VAPT and point-tool stacks, and how delivery works.",
    useCase: "The follow-up when you want the full detail",
    file: "/resources/CyberMon_ASI_Coverage.pdf",
  },
  {
    id: "dri-flyer",
    module: "dri",
    type: "flyer",
    typeLabel: "1-Page Flyer",
    pages: 1,
    title: "DRI Flyer",
    description:
      "“None of this touches your network” — the stealer-log credential, the cloned app, the typosquat domain, and stolen card data on a carding forum.",
    useCase: "Consumer-facing brands, BFSI, e-commerce",
    file: "/resources/CyberMon_DRI_Flyer.pdf",
  },
  {
    id: "dri-coverage",
    module: "dri",
    type: "coverage",
    typeLabel: "Coverage Document",
    pages: 6,
    title: "DRI Coverage Document",
    description:
      "Nine monitored source classes — including carding forums and public code repositories — nine detection capabilities, and takedowns delivered as an analyst-led service.",
    useCase: "The follow-up when you want the full detail",
    file: "/resources/CyberMon_DRI_Coverage.pdf",
  },
  {
    id: "compliance-flyer",
    module: "compliance",
    type: "flyer",
    typeLabel: "1-Page Flyer",
    pages: 1,
    title: "Compliance & Cloud Flyer",
    description:
      "“Your cloud passed the review in March. It is not March any more.” Continuous checks, mapped controls, evidence attached.",
    useCase: "SaaS teams facing SOC 2, retail facing PCI DSS",
    file: "/resources/CyberMon_Compliance_Cloud_Flyer.pdf",
  },
  {
    id: "compliance-coverage",
    module: "compliance",
    type: "coverage",
    typeLabel: "Coverage Document",
    pages: 6,
    title: "Compliance & Cloud Coverage Document",
    description:
      "Four detection surfaces and continuous mapping to SOC 2, ISO 27001, GDPR, PCI DSS and India's DPDP Act.",
    useCase: "The follow-up when you want the full detail",
    file: "/resources/CyberMon_Compliance_Cloud_Coverage.pdf",
  },
  {
    id: "platform-flyer",
    module: "platform",
    type: "flyer",
    typeLabel: "1-Page Flyer",
    pages: 1,
    title: "Platform Flyer",
    description:
      "All three products on one page, led by the correlation argument — one exposed asset, one leaked credential, one failing control, one finding.",
    useCase: "When you don't yet know which product fits",
    file: "/resources/CyberMon_Platform_Flyer.pdf",
  },
  {
    id: "platform-coverage",
    module: "platform",
    type: "coverage",
    typeLabel: "Coverage Document",
    pages: 8,
    title: "Platform Coverage Document",
    description:
      "All three products, the unified risk score, how CyberMon compares against the alternatives, and third-party breach-cost and India market-trend data.",
    useCase: "The full picture in one document",
    file: "/resources/CyberMon_Platform_Coverage.pdf",
  },
];

export function resourcesForModule(moduleKey) {
  return RESOURCES.filter((r) => r.module === moduleKey);
}
